<div class="flex flex-col gap-4">
  @if (!verificationId) {
    <form class="flex flex-col gap-4" [formGroup]="phoneForm">
      <mat-form-field appearance="outline">
        <mat-label>Mobile Number</mat-label>
        <input
          matInput
          formControlName="phoneNumber"
          placeholder="+1 555 000 0000"
          type="tel"
        />
        @if (phoneForm.controls.phoneNumber.hasError('required')) {
          <mat-error>Phone number is required</mat-error>
        }
        @if (phoneForm.controls.phoneNumber.hasError('pattern')) {
          <mat-error>
            Phone number must be in international format, e.g. +61412345678
          </mat-error>
        }
      </mat-form-field>
      <div id="recaptcha-container"></div>
      <pt-loader-button
        type="raised"
        color="primary"
        [loading]="isLoading()"
        [disabled]="!phoneForm.valid"
        (clicked)="sendVerification()"
      >
        Send Verification Code
      </pt-loader-button>
    </form>
  } @else {
    <p class="text-sm text-gray-600">
      Enter the verification code sent to your phone.
    </p>
    <form class="flex flex-col gap-4" [formGroup]="codeForm">
      <mat-form-field appearance="outline">
        <mat-label>Verification Code</mat-label>
        <input
          matInput
          formControlName="code"
          placeholder="123456"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
        />
        @if (codeForm.controls.code.hasError('required')) {
          <mat-error>Code is required</mat-error>
        }
      </mat-form-field>
      <pt-loader-button
        type="raised"
        color="primary"
        [loading]="isLoading()"
        [disabled]="!codeForm.valid"
        (clicked)="confirmEnrolment()"
      >
        Confirm Enrolment
      </pt-loader-button>
      <button type="button" mat-button (click)="resetVerification()">
        Use a different number
      </button>
    </form>
  }

  @if (errorMessage) {
    <p class="text-sm text-red-500">{{ errorMessage }}</p>
  }

  <button mat-stroked-button (click)="auth.logout()">Go Back</button>
</div>
